import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../components/Converter";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import RenderFor, { BM_TYP } from "../../../../../components/RenderFor";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import { decimalSeparator, thousandSeparator } from "../../../../../i18n";
import {
  BemessungenMikropfaehle,
  selectBemessungenMikropfaehle,
} from "../../../../../store/slices/bemessungenMikropfaehleSlice";
import {
  selectTeilsicherheitsbeiwertFuerErmuedungslastenDinEN1991,
  setTeilsicherheitsbeiwertFuerErmuedungslastenDinEN1991,
} from "../../../../../store/slices/innereSlice";

function TeilsicherheitsbeiwertFuerErmuedungslasten() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);
  const teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991 = useSelector(
    selectTeilsicherheitsbeiwertFuerErmuedungslastenDinEN1991
  );

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.partialSafetyFactor")}</p>}
      formulaValue={
        <ToolTip
          id={"TeilsicherheitsbeiwertFuerErmuedungslasten"}
          type={IconType.INFO}
          text={
            bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7
              ? t("inner.fatigue.partialSafetyFactor_subText_ec7")
              : t("inner.fatigue.partialSafetyFactor_subText")
          }
        />
      }
      indicesValue={
        <span>
          &gamma;<sub>Ff</sub>
        </span>
      }
      inputValue={
        <>
          <RenderFor types={[BM_TYP.GERMANY]}>
            <span className="input">
              <NumberFormatText
                value={teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991}
                decimalScale={1}
                fixedDecimalScale={true}
              />
            </span>
          </RenderFor>

          <RenderFor types={[BM_TYP.EUROCODE_7]}>
            <NumberFormat
              className={getClassName(teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991)}
              value={teilsicherheitsbeiwertFuerErmuedungslastenDinEN1991}
              decimalSeparator={decimalSeparator()}
              thousandSeparator={thousandSeparator()}
              displayType="input"
              type="text"
              onValueChange={(value) => {
                dispatch(setTeilsicherheitsbeiwertFuerErmuedungslastenDinEN1991(value.floatValue));
              }}
              allowNegative={true}
              decimalScale={1}
              fixedDecimalScale={true}
            />
          </RenderFor>
        </>
      }
    />
  );
}

export default TeilsicherheitsbeiwertFuerErmuedungslasten;
